export enum ActionsPendency {
  CRMO_CREATED_PENDENCY_HEALTH_INSURANCE = 'CRMO_CREATED_PENDENCY_HEALTH_INSURANCE',
  CRMO_CREATED_PENDENCY_PROVIDER = 'CRMO_CREATED_PENDENCY_PROVIDER',
  CRMO_CREATED_PENDENCY_LAUD = 'CRMO_CREATED_PENDENCY_LAUD',
  CRMO_CREATED_PENDENCY_REPORT = 'CRMO_CREATED_PENDENCY_REPORT',
  CRMO_CREATED_PENDENCY_PERSONALIZED = 'CRMO_CREATED_PENDENCY_PERSONALIZED',
  CRMO_CREATED_PENDENCY_AUTH_DIVERGENCE = 'CRMO_CREATED_PENDENCY_AUTH_DIVERGENCE'
}

// TODO: Make this enum localized available
// export enum ActionsPendencyLocalized {
//   CRMO_CREATED_PENDENCY_HEALTH_INSURANCE = 'Pendência de documentação inicial',
//   CRMO_CREATED_PENDENCY_PROVIDER = 'Pendência de documentação após solicitação na operadora',
//   CRMO_CREATED_PENDENCY_LAUD = 'CRMO_CREATED_PENDENCY_LAUD',
//   CRMO_CREATED_PENDENCY_REPORT = 'CRMO_CREATED_PENDENCY_REPORT',
//   CRMO_CREATED_PENDENCY_PERSONALIZED = 'Pendência personalizada'
// }

export enum PendencyDocInitialListEnum {
  HEALTH_INSURANCE_CARD = 'HEALTH_INSURANCE_CARD',
  SURGERY_REPORT_JUSTIFY = 'SURGERY_REPORT_JUSTIFY',
  PROVIDERS_INDICATION = 'PROVIDERS_INDICATION',
  OTHERS = 'OTHERS'
}

export enum PendencyDocInitialListEnumLocalized {
  HEALTH_INSURANCE_CARD = 'Carteira do convênio',
  SURGERY_REPORT_JUSTIFY = 'Laudo que comprove a patalogia que justifique a cirurgia',
  PROVIDERS_INDICATION = 'Indicação de três fornecedores (exigência da ANS) caso tenha informação de OPME no pedido médico',
  OTHERS = 'Outros'
}

export enum PendencyAfterOperatorRequestListEnum {
  SUPPLEMENTARY_MEDICAL_REPORT = 'SUPPLEMENTARY_MEDICAL_REPORT',
  EXAM_REPORTS_PHOTOS = 'EXAM_REPORTS_PHOTOS',
  SUPPLIERS = 'SUPPLIERS'
}

export enum PendencyAfterOperatorRequestListEnumLocalized {
  SUPPLEMENTARY_MEDICAL_REPORT = 'Relatório médico complementar',
  EXAM_REPORTS_PHOTOS = 'Laudo de exames/fotos',
  SUPPLIERS = 'Fornecedores'
}
